import { render, staticRenderFns } from "./SecurityProfileRequestPin.vue?vue&type=template&id=1ccb55b7&scoped=true"
import script from "./SecurityProfileRequestPin.vue?vue&type=script&lang=js"
export * from "./SecurityProfileRequestPin.vue?vue&type=script&lang=js"
import style0 from "./SecurityProfileRequestPin.vue?vue&type=style&index=0&id=1ccb55b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccb55b7",
  null
  
)

export default component.exports